import React, { useEffect } from 'react';

import Header from '../../components/Header/Home/Header.js';
import Maps from '../../components/Mapa/MapaDireito';

import './styles.css'

export default function HomePage() {
    useEffect(()=>{
        localStorage.removeItem('adm')
    })
    return (
        <>
            <Header />
            <Maps />
        </>
    )
}